require('/tools/js/svg/templates/svg.module.scss.module.css');

export const alignIcon = "_align-icon_ezd4t_1";
